export const processEventLabel = (label: string): string =>
  label?.toLowerCase().replace(/[&\s]+/g, "-") || "";
